<template>
  <div>
    <customer-setting-form
      :customer-setting-data="customerSettingData"
      @updateEditData="updateCustomerSettingData"
    />
    <div class="container">
      <button
        type="button"
        class="btn btn-primary btn-block"
        :disabled="!isActivateButton"
        @click="saveCustomerSettingHandler"
      >
        {{ $t("General.Update") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CustomerSettingForm from './CustomerSettingForm.vue'

export default {
  components: {
    CustomerSettingForm
  },
  data: () => ({
    customerSettingData: {},
    editData: {}
  }),
  computed: {
    ...mapState('auth', [
      'uid',
      'customerName',
      'customerSetting'
    ]),
    isActivateButton() {
      return Object.keys(this.editData).length
    }
  },
  watch: {
    customerName: {
      handler: function(v, _) {
        this.customerSettingData = {
          name: v,
          ...this.customerSetting
        }
      }
    },
    customerSetting: {
      handler: function(v, _) {
        this.customerSettingData = {
          ...v,
          name: this.customerName
        }
      }
    }
  },
  methods: {
    ...mapActions('auth', [
      'saveCustomerSetting',
      'loadCustomerSetting'
    ]),
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    updateCustomerSettingData(val) {
      this.editData = Object.assign({}, val)
    },
    saveCustomerSettingHandler() {
      this.setLoadingState('updateCustomerSetting')
      this.saveCustomerSetting({
        uid: this.uid,
        data: this.editData
      }).then(() => {
        return this.loadCustomerSetting(this.uid)
      }).catch((err) => {
        return Promise.reject(err)
      }).finally(() => {
        this.unsetLoadingState('updateCustomerSetting')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
